import { useSelector, useDispatch } from "react-redux";
import cn from "classnames";

import Badge from "./components/Badge";
import { GlobalState } from "../../../../store/types";
import { setBadgeCount } from "../../../../store/actions";

import "./style.scss";

import openLauncher from "../../../../../assets/launcher_button.svg";
import close from "../../../../../assets/clear-button.svg";
import { Dispatch } from "redux";
import { SetBadgeCount } from "src/react-chat-widget/src/store/actions/types";

type Props = {
  toggle: () => void;
  chatId: string;
  openLabel: string;
  closeLabel: string;
  closeImg: string;
  openImg: string;
  showBadge?: boolean;
  color: string;
};

function Launcher({
  toggle,
  chatId,
  openImg,
  closeImg,
  openLabel,
  closeLabel,
  showBadge,
  color,
}: Props) {
  const dispatch = useDispatch<Dispatch<SetBadgeCount>>();
  const { showChat, badgeCount } = useSelector((state: GlobalState) => ({
    showChat: state.behavior.showChat,
    badgeCount: state.messages.badgeCount,
  }));

  const toggleChat = () => {
    toggle();
    if (!showChat) dispatch(setBadgeCount(0));
  };

  return (
    <button
      type="button"
      className={cn("rcw-launcher", { "rcw-hide-sm": showChat })}
      onClick={toggleChat}
      aria-controls={chatId}
    >
      {!showChat && showBadge && <Badge badge={badgeCount} />}
      {showChat ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          width="20px"
          height="20px"
          viewBox="0 0 357 357"
          className="rcw-close-launcher"
        >
          <g>
            <g id="clear">
              <polygon
                points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3     214.2,178.5   "
                fill={color}
              />
            </g>
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
      ) : (
        <svg
          width="34px"
          height="32px"
          viewBox="0 0 34 32"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          className="rcw-open-launcher"
        >
          <title>ic_button</title>
          <desc>Created with Sketch.</desc>
          <defs></defs>
          <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Desktop-HD"
              transform="translate(-1299.000000, -748.000000)"
              fillRule="nonzero"
              fill={color}
            >
              <g id="Group-2" transform="translate(1289.000000, 735.000000)">
                <g id="ic_button" transform="translate(10.206933, 13.607825)">
                  <path
                    d="M25.7865398,7.37051863 C25.7865398,8.40803118 25.0432026,9.0390109 24.5004161,9.50205642 C24.2948517,9.67744388 23.9122271,9.9974623 23.9132484,10.1169975 C23.9169623,10.5858924 23.5459436,10.9603479 23.0843986,10.9603479 C23.0820775,10.9603479 23.0797563,10.9603479 23.0774351,10.9603479 C22.6191398,10.9603479 22.2457071,10.5974025 22.2419932,10.1308662 C22.2346582,9.21128497 22.8950826,8.66059289 23.4257989,8.20783098 C23.84222,7.85252751 24.1152846,7.60251311 24.1152846,7.37372636 C24.1152846,6.91058649 23.7444516,6.53377235 23.2886632,6.53377235 C22.832689,6.53377235 22.4617632,6.91058649 22.4617632,7.37372636 C22.4617632,7.84271562 22.0876806,8.22283184 21.6261356,8.22283184 C21.1645906,8.22283184 20.790508,7.84271562 20.790508,7.37372636 C20.790508,5.97421183 21.9110846,4.83556138 23.2884775,4.83556138 C24.6659632,4.83546703 25.7865398,5.97090976 25.7865398,7.37051863 Z M23.1005541,11.7441666 C22.6390091,11.7441666 22.2834031,12.1242828 22.2834031,12.5932721 L22.2834031,12.5997819 C22.2834031,13.0687712 22.639102,13.4456797 23.1005541,13.4456797 C23.5620063,13.4456797 23.9361817,13.0622614 23.9361817,12.5932721 C23.9361817,12.1242828 23.5620991,11.7441666 23.1005541,11.7441666 Z M6.2571796,17.6589411 C5.79563462,17.6589411 5.42155199,18.0390573 5.42155199,18.5080466 C5.42155199,18.9770358 5.79563462,19.357152 6.2571796,19.357152 L6.32681524,19.357152 C6.78836023,19.357152 7.16244286,18.9770358 7.16244286,18.5080466 C7.16244286,18.0390573 6.78836023,17.6589411 6.32681524,17.6589411 L6.2571796,17.6589411 Z M9.16135697,17.6589411 C8.69981198,17.6589411 8.32572935,18.0390573 8.32572935,18.5080466 C8.32572935,18.9770358 8.69981198,19.357152 9.16135697,19.357152 L9.23089975,19.357152 C9.69244474,19.357152 10.0665274,18.9770358 10.0665274,18.5080466 C10.0665274,18.0390573 9.69244474,17.6589411 9.23089975,17.6589411 L9.16135697,17.6589411 Z M33.7036473,4.09693395 L33.7036473,13.6541822 C33.7036473,15.9170483 31.9180039,17.7532861 29.6910563,17.7532861 L18.8541731,17.7532861 C18.6422951,17.7532861 18.4678346,17.7520596 18.3218783,17.7489463 C18.1689585,17.7457385 17.9968192,17.744512 17.9296904,17.7520596 C17.8597762,17.7992322 17.6883797,17.9587697 17.523204,18.1134012 C17.4577465,18.1746311 17.3836542,18.2419935 17.3037125,18.3161487 L14.2377019,21.1557461 C13.9931415,21.3824573 13.6313148,21.4411399 13.3284462,21.3054717 C13.0255776,21.1697092 12.8129568,20.8649747 12.8129568,20.5286346 L12.8129568,11.5265126 L4.05929327,11.5265126 C2.75367154,11.5265126 1.67125524,12.6136506 1.67125524,13.9401421 L1.67125524,23.4973904 C1.67125524,24.8239762 2.75376439,25.8669607 4.05929327,25.8669607 L16.1641949,25.8669607 C16.3726376,25.8669607 16.5676174,25.9642305 16.7215586,26.1070689 L19.2194352,28.4472036 L19.2194352,20.3770221 C19.2194352,19.9080328 19.5935178,19.5279166 20.0550628,19.5279166 C20.5166078,19.5279166 20.8906905,19.9080328 20.8906905,20.3770221 L20.8906905,30.3717484 C20.8906905,30.7080885 20.7012815,31.0082944 20.3983201,31.144057 C20.289967,31.1926447 20.1811498,31.2117967 20.0672259,31.2117967 C19.8625899,31.2117967 19.6607394,31.1264144 19.5037343,30.9807457 L15.84025,27.5650774 L4.05929327,27.5650774 C1.83225282,27.5650774 0,25.7602565 0,23.497296 L0,13.9401421 C0,11.677276 1.83225282,9.82830162 4.05929327,9.82830162 L12.8129568,9.82830162 L12.8129568,4.09693395 C12.8129568,1.8339735 14.6592296,0.0164160393 16.8862701,0.0164160393 L29.6911491,0.0164160393 C31.9180039,0.0164160393 33.7036473,1.8339735 33.7036473,4.09693395 Z M32.032392,4.09693395 C32.032392,2.77034816 30.9964923,1.714627 29.6910563,1.714627 L16.8862701,1.714627 C15.5807412,1.714627 14.484212,2.77034816 14.484212,4.09693395 L14.484212,10.6853321 L14.484212,18.6040898 L16.1642878,17.0612652 C16.242094,16.9890912 16.3292778,16.9230497 16.3928784,16.8634236 C17.1600774,16.1450803 17.356357,16.0302624 18.3570675,16.051207 C18.4935534,16.0541317 18.6561294,16.0551695 18.8541731,16.0551695 L29.6910563,16.0551695 C30.9964923,16.0551695 32.032392,14.980768 32.032392,13.6542766 L32.032392,4.09693395 Z"
                    id="Shape"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )}
    </button>
  );
}

export default Launcher;
